import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
export function CryingObjection() {
  return <section className="py-20 px-4 bg-[#0f182e]" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-[#1e293b] to-[#0f172a] p-8 md:p-12 rounded-2xl border border-amber-500/10 relative overflow-hidden" data-id="element-15">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-amber-500/5 rounded-full blur-3xl" data-id="element-16"></div>

          <div className="relative z-10" data-id="element-17">
            <div className="flex items-center mb-6" data-id="element-18">
              <Heart className="text-rose-400 w-8 h-8 mr-4" fill="currentColor" fillOpacity={0.2} data-id="element-19" />
              <h2 className="text-3xl font-serif text-cream" data-id="element-20">
                ¿Y si mi bebé llora?
              </h2>
            </div>

            <div className="space-y-6 text-lg text-amber-50/90 leading-relaxed" data-id="element-21">
              <p data-id="element-22">Puede llorar. Porque está frustrado con el cambio.</p>

              <div className="space-y-2 font-medium text-amber-200" data-id="element-23">
                <p data-id="element-24">La diferencia es:</p>
                <p data-id="element-25">Aquí no lo dejas solo.</p>
                <p data-id="element-26">No lo "abandonas".</p>
                <p data-id="element-27">No lo rompes.</p>
              </div>

              <p className="text-xl font-serif italic text-cream" data-id="element-28">
                Lo acompañas con estructura.
              </p>

              <p data-id="element-29">
                El objetivo no es "cero llanto". El objetivo es que el llanto no
                sea el precio de tu culpa… ni el precio de tu sueño.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}